<template>
  <vuex-table
    :fields="fields"
    :show_per_page="false"
    table_store="pbx/stats/general/table"
    :tooltip_text="$t('pbx.stat.tooltips.one_sip_account')"
  >
    >
    <template
      v-if="filter.group_by === 'sip_account' && !item.group"
      slot="group"
      slot-scope="{ item }"
    >
      <tooltip
        placement="top"
        theme="light"
        min-width="300"
        max-width="300"
        :transfer="true"
        :content="$t('pbx.stat.tooltips.sip_not_fixed')"
      >
        {{ $t('pbx.stat.sip_not_fixed') }}
        <icon size="18" type="ios-help-circle-outline" />
      </tooltip>
    </template>
  </vuex-table>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { seconds_to_time } from '@shared/helpers/time';

  export default {
    computed: {
      ...mapGetters('pbx/stats/general/table', ['filter']),
      fields() {
        console.log('data', this.filter);
        return [
          {
            key: 'group',
            label: '',
            sortable: false,
            thStyle: {
              'min-width': '150px'
            },
            class: 'column-sticky'
          },
          { key: 'internal', label: this.$t('pbx.stat.common.field.internal'), sortable: false },
          { key: 'external', label: this.$t('pbx.stat.common.field.external'), sortable: false },
          { key: 'incoming', label: this.$t('pbx.stat.common.field.incoming'), sortable: false },
          { key: 'outgoing', label: this.$t('pbx.stat.common.field.outgoing'), sortable: false },
          { key: 'total', label: this.$t('pbx.stat.common.field.total'), sortable: false },
          { key: 'answered', label: this.$t('pbx.stat.type_answer.ANSWERED'), sortable: false },
          { key: 'no_answer', label: this.$t('pbx.stat.type_answer.NO_ANSWER'), sortable: false },
          { key: 'canceled', label: this.$t('pbx.stat.type_answer.CANCELED'), sortable: false },
          { key: 'failed', label: this.$t('pbx.stat.type_answer.FAILED'), sortable: false },
          { key: 'rejected', label: this.$t('pbx.stat.type_answer.REJECTED'), sortable: false },
          {
            key: 'acd',
            label: this.$t('pbx.stat.common.field.acd'),
            sortable: false,
            formatter: (value) => seconds_to_time(value)
          },
          {
            key: 'asr',
            label: this.$t('pbx.stat.common.field.asr'),
            sortable: false,
            formatter: (value) => this.$numeral.percentage(value)
          },
          {
            key: 'duration',
            label: this.$t('pbx.stat.table.field.duration'),
            sortable: false,
            formatter: (value) => seconds_to_time(value)
          }
        ];
      }
    }
  };
</script>
